// ═══════════════════════════════════════════════════════════════════════════════
// Módulo: Financiamento — Utilitários de badges de risco compartilhados
// Uses centralized riskTokens from design system
// ═══════════════════════════════════════════════════════════════════════════════

import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Minus, TrendingUp, TrendingDown } from 'lucide-react';
import { riskColor, riskTailwindText, riskTailwindBg } from '@/lib/riskTokens';

export const riskBadge = (classificacao: string | null) => {
  const map: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
    'crítico': { label: 'Crítico', variant: 'destructive' },
    'critico': { label: 'Crítico', variant: 'destructive' },
    'alto': { label: 'Alto', variant: 'destructive' },
    'moderado': { label: 'Moderado', variant: 'secondary' },
    'baixo': { label: 'Baixo', variant: 'outline' },
  };
  const m = map[classificacao || ''] || { label: classificacao || '—', variant: 'outline' as const };
  return <Badge variant={m.variant} className="text-xs">{m.label}</Badge>;
};

export const trendIcon = (tendencia: string | null) => {
  if (tendencia === 'piorando') return <span title="Risco piorando"><TrendingUp className="h-4 w-4 text-destructive" /></span>;
  if (tendencia === 'melhorando') return <span title="Risco melhorando"><TrendingDown className="h-4 w-4 text-success" /></span>;
  return <span title="Estável"><Minus className="h-4 w-4 text-muted-foreground" /></span>;
};

export const scoreColor = (s: number | null) => {
  if (s == null) return '';
  if (s >= 70) return 'text-destructive';
  if (s >= 40) return 'text-warning';
  return 'text-success';
};

export const riskDistColor = (level: string) => {
  return riskTailwindBg(level) || 'bg-muted';
};

export const performanceBandColor = (label: string) => {
  const map: Record<string, string> = {
    'Excelente': 'bg-success',
    'Bom': 'bg-info',
    'Atenção': 'bg-warning',
    'Crítico': 'bg-destructive',
  };
  return map[label] || 'bg-muted';
};
